import { inject, Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { BoardV3RealtimeService } from './board-v3-realtime.service';

const FUNNEL_PRESENCE_HEARTBEAT_INTERVAL_MS = 15_000;
const CARD_PRESENCE_HEARTBEAT_INTERVAL_MS = 15_000;

@Injectable({ providedIn: 'root' })
export class BoardV3PresenceService {
  private readonly realtimeService = inject(BoardV3RealtimeService);

  funnelHeartbeat$(funnelId: string, isActive: () => boolean): Observable<void> {
    return timer(FUNNEL_PRESENCE_HEARTBEAT_INTERVAL_MS, FUNNEL_PRESENCE_HEARTBEAT_INTERVAL_MS).pipe(
      tap(() => {
        if (isActive()) this.realtimeService.pingFunnelPresence(funnelId);
      }),
      map(() => undefined),
    );
  }

  cardHeartbeat$(
    cardId: string,
    companyId: string,
    funnelId: string | undefined,
    isActive: () => boolean,
  ): Observable<void> {
    return timer(CARD_PRESENCE_HEARTBEAT_INTERVAL_MS, CARD_PRESENCE_HEARTBEAT_INTERVAL_MS).pipe(
      tap(() => {
        if (isActive()) this.realtimeService.pingCardPresence(cardId, companyId, funnelId);
      }),
      map(() => undefined),
    );
  }
}
